import { Link, useLocation } from "react-router-dom"
import { Home, Users, Calendar, MessageCircle, Plus } from "lucide-react"
import { Button } from "./ui/button"
import { ThemeToggle } from "./ui/theme-toggle"
import { cn } from "@/lib/utils"

export function Header() {
  const location = useLocation()
  
  const navigation = [
    { name: 'Home', href: '/', icon: Home },
    { name: 'Beta Access', href: '/beta', icon: Users },
    { name: 'Book Demo', href: '/demo', icon: Calendar },
    { name: 'Contact', href: '/contact', icon: MessageCircle },
    { name: 'Request Integration', href: '/request', icon: Plus },
  ]

  return (
    <header className="fixed top-0 z-50 w-full border-b bg-white/80 backdrop-blur-lg supports-[backdrop-filter]:bg-white/60 dark:bg-gray-950/80 dark:supports-[backdrop-filter]:bg-gray-950/60">
      <div className="container flex h-16 items-center justify-between px-6">
        <Link to="/" className="flex items-center space-x-2">
          <div className="h-8 w-8 rounded-full bg-gradient-to-r from-purple-500 to-pink-500"></div>
          <span className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            Score Forms
          </span>
        </Link>
        
        <nav className="hidden md:flex items-center space-x-1">
          {navigation.map((item) => {
            const Icon = item.icon
            return (
              <Link
                key={item.name}
                to={item.href}
                className={cn(
                  "flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-purple-50 dark:hover:bg-purple-900/20",
                  location.pathname === item.href
                    ? "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300"
                    : "text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400"
                )}
              >
                <Icon className="h-4 w-4" />
                <span>{item.name}</span>
              </Link>
            )
          })}
        </nav>

        <div className="flex items-center gap-4">
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
}